module.exports = __webpack_public_path__ + "media/event-access/webinar@1x-b9cf4934.png";